import { SavingState } from '../../reducers/savingState';
import { ForsikringOppsummeringInformation } from '../../types/internal-types';
import {
    UpdateSkademeldingOppsumeringBonusInfo,
    UpdateSkademeldingOppsumeringEgenandelInfo,
    UpdateSkademeldingOppsumeringKjorelengdeInfo,
    UpdateSkademeldingOppsumeringResetSavingState,
    UpdateSkademeldingOppsumeringSavingStateToFinished,
    UpdateSkademeldingOppsumeringSavingStateToOngoing,
} from './skademeldingOppsummering-actions';

export interface SkademeldingOppsummeringState {
    forsikringOppsummeringInformation: ForsikringOppsummeringInformation;
    savingState: SavingState;
}

const initialSkademeldingOppsummeringState: SkademeldingOppsummeringState = {
    forsikringOppsummeringInformation: { kjorelengde: undefined, bonus: undefined, egenandel: undefined },
    savingState: SavingState.Initial,
};

export enum SkademeldingOppsummeringActionKeys {
    UpdateBonusOppsummeringInfo = 'SKADEMELDING_BONUS_INFO',
    UpdateEgenandelOppsummeringInfo = 'SKADEMELDING_EGENANDEL_INFO',
    UpdateKjorelengdeOppsummeringInfo = 'SKADEMELDING_KJORELENGDE_INFO',
    UpdateSavingStateToFetching = 'SKADEMELDING_OPPSUMMERING_FETCHING',
    UpdateSavingStateToFinished = 'SKADEMELDING_OPPSUMMERING_FINISHED',
    ResetSavingState = 'SKADEMELDING_OPPSUMMERING_RESET_SAVING_STATE',
}

type SkademeldingOppsummeringActions =
    | UpdateSkademeldingOppsumeringBonusInfo
    | UpdateSkademeldingOppsumeringEgenandelInfo
    | UpdateSkademeldingOppsumeringKjorelengdeInfo
    | UpdateSkademeldingOppsumeringSavingStateToOngoing
    | UpdateSkademeldingOppsumeringSavingStateToFinished
    | UpdateSkademeldingOppsumeringResetSavingState
    | never;

export const skademeldingOppsummeringReducer = (
    state: SkademeldingOppsummeringState = initialSkademeldingOppsummeringState,
    action: SkademeldingOppsummeringActions = {} as SkademeldingOppsummeringActions,
): SkademeldingOppsummeringState => {
    switch (action.type) {
        case SkademeldingOppsummeringActionKeys.UpdateBonusOppsummeringInfo:
            return {
                ...state,
                forsikringOppsummeringInformation: {
                    ...state.forsikringOppsummeringInformation,
                    bonus: action.forsikringOppsummeringInformation.bonus,
                },
            };
        case SkademeldingOppsummeringActionKeys.UpdateEgenandelOppsummeringInfo:
            return {
                ...state,
                forsikringOppsummeringInformation: {
                    ...state.forsikringOppsummeringInformation,
                    egenandel: action.forsikringOppsummeringInformation.egenandel,
                },
            };
        case SkademeldingOppsummeringActionKeys.UpdateKjorelengdeOppsummeringInfo:
            return {
                ...state,
                forsikringOppsummeringInformation: {
                    ...state.forsikringOppsummeringInformation,
                    kjorelengde: action.forsikringOppsummeringInformation.kjorelengde,
                },
            };

        case SkademeldingOppsummeringActionKeys.UpdateSavingStateToFetching:
            return {
                ...state,
                savingState: SavingState.Saving,
            };

        case SkademeldingOppsummeringActionKeys.UpdateSavingStateToFinished:
            return {
                ...state,
                savingState: SavingState.Success,
            };

        case SkademeldingOppsummeringActionKeys.ResetSavingState:
            return {
                ...initialSkademeldingOppsummeringState,
            };
        default:
            return {
                ...state,
            };
    }
};
